// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import Vant from 'vant';
import 'vant/lib/index.css';
import qs from 'qs';
import Viser from 'viser-vue'
Vue.use(Viser)
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
import { DatetimePicker } from 'vant';
Vue.use(DatetimePicker);
import { Popup } from 'vant';
Vue.use(Popup);
//import VideoPlayer from 'vue-video-player'
//require('video.js/dist/video-js.css')
//require('vue-video-player/src/custom-theme.css')
//Vue.use(VideoPlayer)

Vue.use(Vant);
Vue.use(ElementUI)
axios.defaults.headers.common['token']
Vue.prototype.tajax=axios
Vue.prototype.$qs = qs;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js